import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Password } from 'src/app/interfaces/password';
import { Response } from 'src/app/interfaces/response';
import { RestablecerPassword } from 'src/app/interfaces/restablecerPassword';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RestablecerPasswordService {

    private baseApiUrl = environment.baseApi + '/publico/restablecer';

    constructor(private httpClient: HttpClient) { }

    async obtenerTokenActivo(token:string, rol:string):Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApiUrl}/verificar-token/${token}/${rol}`).toPromise();
    }

    enviarToken(correo: string):Observable<Response>{
        return this.httpClient.post<Response>(`${this.baseApiUrl}/enviar-correo`,correo)
    }

    restablecerPassword(password: Password): Observable<Response>{
        return this.httpClient.put<Response>(`${this.baseApiUrl}/cambiar-password`, password)
    }
}
